import { z } from 'zod';

export const PERSONA_BRIEF_DURATIONS = ['15 seconds', '30 seconds', '60 seconds'] as const;
export const PERSONA_BRIEF_AGE_RANGES = [
  '18-24',
  '25-34',
  '35-44',
  '45+',
  'Open To All',
] as const;
export const PERSONA_BRIEF_GENDERS = ['Male', 'Female', 'Both'] as const;

/** Stored `hookPackage` values. UI labels live in `PERSONA_BRIEF_HOOK_PACKAGE_LABELS`. */
export const PERSONA_BRIEF_HOOK_PACKAGES = [1, 4] as const;
export const PERSONA_BRIEF_HOOK_PACKAGE_LABELS = {
  1: '1 Hook',
  4: '4 Hooks',
} as const;

export const PersonaBriefDurationSchema = z.enum(PERSONA_BRIEF_DURATIONS);
export type PersonaBriefDuration = z.infer<typeof PersonaBriefDurationSchema>;

export const PersonaBriefAgeRangeSchema = z.enum(PERSONA_BRIEF_AGE_RANGES);
export type PersonaBriefAgeRange = z.infer<typeof PersonaBriefAgeRangeSchema>;

export const PersonaBriefGenderSchema = z.enum(PERSONA_BRIEF_GENDERS);
export type PersonaBriefGender = z.infer<typeof PersonaBriefGenderSchema>;

export const PersonaBriefHookPackageSchema = z.union([z.literal(1), z.literal(4)]);
export type PersonaBriefHookPackage = z.infer<typeof PersonaBriefHookPackageSchema>;
